"use client";

import styles from "./key-bpm-finder.module.scss";
import UploadDragAndDrop from "@/components/common/upload-drag-and-drop";
import { audio } from "@/data/extensions";
import {
  FINDER_FILES_ALLOWED,
  useKeyBpmFinder,
} from "@/components/pages/key-bpm-finder/hooks/use-key-bpm-finder";
import KeyBpmDetectorFileCard from "@/components/pages/key-bpm-finder/components/key-bpm-finder-file-card";
import { useAudioPlayerContext } from "@/hooks/audio/use-audio-player-context";
import ServicePageHeader from "@/components/common/service-page-header";

const KeyBpmDetector = () => {
  const { files, isLoading, handleFilesAdded } = useKeyBpmFinder();
  const { handlePlayButtonClick, isPlayerActive } = useAudioPlayerContext();

  return (
    <div className={styles.wrapper}>
      <ServicePageHeader
        title={
          <>
            Key & <span>BPM</span> finder
          </>
        }
        description={"Find the key and BPM of any song"}
      />
      <div>
        <UploadDragAndDrop
          handleFilesAdded={handleFilesAdded}
          acceptedFiles={audio}
          topText={`Add or drop up to ${FINDER_FILES_ALLOWED} files`}
          bottomText="Or Drag And Drop *mp3, *wav, *ogg, *m4r, *m4a, *flac, *aac, *opus File Here"
          isActive={!isLoading}
        />
      </div>
      <div className={styles.files_wrapper}>
        {files.length === 0 ? (
          <div className={styles.empty_text}>Your outputs will appear here</div>
        ) : (
          <div className={styles.file_cards_container}>
            {files.map((file, i) => (
              <KeyBpmDetectorFileCard
                key={i}
                finderFile={file}
                handlePlayTrack={handlePlayButtonClick}
                isPlayerActive={isPlayerActive}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default KeyBpmDetector;
